import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { FileEarmarkExcel, FileEarmarkPdf, Pencil, Trash } from 'react-bootstrap-icons';
import './adminpage.css';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { exportToPDF } from './PdfSection';
import AdminNavbar from './AdminNavbar';
import Dashboard from './Dashboard';
import { Modal } from 'react-bootstrap';
import { generarTicket } from './generarTicket';
import municipiosYColonias from "../data/municipios.json";
import Select from 'react-select';
import articulosData from '../data/articulos.json';
import {
    createUser as apiCreateUser,
    deleteUser as apiDeleteUser,
    fetchCurrentUser,
    fetchInfracciones as apiFetchInfracciones,
    fetchUsers as apiFetchUsers,
    findUserByName,
    softDeleteInfraccion,
    updateInfraccion,
    updateUser as apiUpdateUser,
    uploadInfraccionPhoto,
} from "../services/api";
import { clearSessionData, getStoredUser, setSessionData } from "../utils/session";

const getArticulosArray = (articulosVal) => {
    if (!articulosVal) return [];
    if (Array.isArray(articulosVal)) return articulosVal;
    try {
        const parsed = JSON.parse(articulosVal);
        if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
    if (typeof articulosVal === "string") {
        return articulosVal.split(",").map(item => item.trim()).filter(Boolean);
    }
    return [];
};

export default function AdminPage() {
    const [editingInfraccionId, setEditingInfraccionId] = useState(null);
    const [editedInfraccionData, setEditedInfraccionData] = useState({});
    const [users, setUsers] = useState([]);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nombre, setNombre] = useState('');
    const [rol, setRole] = useState('user');
    const [matricula, setMatricula] = useState('');
    const [nomina, setNomina] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [error, setError] = useState(null);
    const [infracciones, setInfracciones] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [nombreSesion, setNombreSesion] = useState('');
    const [userRole, setUserRole] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [filterIncidencia, setFilterIncidencia] = useState('Todas');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteReason, setDeleteReason] = useState('');
    const [infraccionToDelete, setInfraccionToDelete] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);

    useEffect(() => {
        async function fetchNombreSesion() {
            const localUser = getStoredUser();
            if (localUser?.nombre) {
                setNombreSesion(localUser.nombre);
            }
            if (localUser?.rol) {
                setUserRole(localUser.rol);
            }

            try {
                const userData = await fetchCurrentUser();
                if (userData?.nombre) {
                    setNombreSesion(userData.nombre);
                    setSessionData(userData);
                }
                if (userData?.rol) {
                    setUserRole(userData.rol);
                }
            } catch (error) {
                console.warn('No se pudo refrescar la sesion en admin:', error);
            }
        }

        fetchNombreSesion();
    }, []);

    useEffect(() => {
        fetchInfracciones();
    }, []);

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery, filterIncidencia, startDate, endDate]);

    async function fetchUsers() {
        const localUser = getStoredUser();
        if (localUser?.rol === 'director') return;
        try {
            const data = await apiFetchUsers();
            if (data) setUsers(data);
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
        }
    }

    async function handleSaveInfraccion() {
        const original = infracciones.find(i => i.id === editingInfraccionId);
        
        // Limpieza y comparación de Fecha
        const editadaFecha = editedInfraccionData.fecha?.split("T")[0];
        const originalFecha = original?.fecha?.split("T")[0];

        if (editadaFecha === originalFecha) {
            delete editedInfraccionData.fecha;
        } else if (editedInfraccionData.fecha) {
            editedInfraccionData.fecha = editadaFecha;
        }

        // Limpieza y comparación de Emisión de Licencia
        const editadaEmision = editedInfraccionData.infractor_emision?.split("T")[0];
        const originalEmision = original?.infractor_emision?.split("T")[0];

        if (editadaEmision === originalEmision) {
            delete editedInfraccionData.infractor_emision;
        } else {
            editedInfraccionData.infractor_emision = editadaEmision || null;
        }

        const updatedData = {
            ...editedInfraccionData,
            editada: true
        };

        try {
            await updateInfraccion(editingInfraccionId, updatedData);
            fetchInfracciones();
            setEditingInfraccionId(null);
            setEditedInfraccionData({});
            alert('Infracción actualizada correctamente.');
        } catch (error) {
            console.error('Error al actualizar infraccion:', error);
            alert('Hubo un error al guardar los cambios.');
        }
    }


    async function fetchInfracciones() {
        try {
            const data = await apiFetchInfracciones({ eliminado: false });
            if (data) setInfracciones(data);
        } catch (error) {
            console.error('Error al obtener infracciones:', error);
        }
    }

    // Filtrar infracciones
    const filteredInfracciones = infracciones.filter(inf => {
        const fullConductorName = `${inf.infractor_nombre ?? ''} ${inf.infractor_apellido_paterno ?? ''} ${inf.infractor_apellido_materno ?? ''}`.toLowerCase();
        const searchLower = searchQuery.toLowerCase();
        const matchText = inf.id.toString().includes(searchLower) ||
            (inf.agente && inf.agente.toLowerCase().includes(searchLower)) ||
            (fullConductorName && fullConductorName.includes(searchLower)) ||
            (inf.fecha && inf.fecha.toLowerCase().includes(searchLower));

        const matchIncidencia = filterIncidencia === 'Todas' || inf.incidencia === filterIncidencia;

        let matchFecha = true;
        if (inf.fecha) {
            const infFechaStr = inf.fecha.split('T')[0];
            if (startDate && infFechaStr < startDate) matchFecha = false;
            if (endDate && infFechaStr > endDate) matchFecha = false;
        } else if (startDate || endDate) {
            matchFecha = false;
        }

        return matchText && matchIncidencia && matchFecha;
    });

    const totalItems = filteredInfracciones.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentInfracciones = filteredInfracciones.slice(indexOfFirstItem, indexOfLastItem);

    const openDeleteModal = (inf) => {
        setInfraccionToDelete(inf);
        setShowDeleteModal(true);
    };

    const confirmDeleteInfraccion = async () => {
        if (!deleteReason.trim()) {
            alert("Por favor escribe un motivo.");
            return;
        }

        try {
            await softDeleteInfraccion(infraccionToDelete.id, deleteReason);
            setShowDeleteModal(false);
            setDeleteReason('');
            setInfraccionToDelete(null);
            fetchInfracciones();
        } catch (error) {
            alert("Error al eliminar infracción");
            console.error(error);
        }
    };


    async function handleAddUser(e) {
        e.preventDefault();
        setError(null);

        // Verificar que todos los campos estén completos
        if (!email || !password || !nombre || !matricula || !nomina) {
            setError('Todos los campos son obligatorios');
            return;
        }

        // Validación de contraseña
        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
        // Explicación:
        // (?=.*[0-9]) → al menos un número
        // (?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]) → al menos un carácter especial
        // .{8,} → mínimo 8 caracteres

        if (!passwordRegex.test(password)) {
            setError('La contraseña debe tener mínimo 8 caracteres, al menos un número y un carácter especial.');
            return;
        }

        try {
            await apiCreateUser({
                email,
                password,
                nombre,
                matricula,
                rol,
                nomina,
            });

            resetUserForm();
            fetchUsers();
            setShowUserModal(false);
            alert('Usuario agregado correctamente.');
        } catch (error) {
            console.error('Error al crear usuario:', error);
            setError(error?.response?.data?.message || error.message || 'No se pudo crear el usuario');
        }
    }



    async function handleEditUser(e) {
        e.preventDefault();
        setError(null);

        // Validación de contraseña si se ingresó
        if (password) {
            const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;
            if (!passwordRegex.test(password)) {
                setError('La nueva contraseña debe tener mínimo 8 caracteres, al menos un número y un carácter especial.');
                return;
            }
        }

        try {
            await apiUpdateUser(selectedUser.uid, {
                nombre,
                matricula,
                rol,
                nomina,
                password: password || undefined
            });

            resetUserForm();
            fetchUsers();
            setShowUserModal(false);
            alert('Usuario actualizado correctamente.');
        } catch (error) {
            setError(error?.response?.data?.message || error.message);
        }
    }

    async function handleDeleteUser(uid) {
        const currentUser = getStoredUser();

        if (String(uid) === String(currentUser?.uid || currentUser?.id)) {
            return alert("No puedes eliminar tu propio usuario");
        }

        if (!window.confirm('¿Seguro que deseas eliminar este usuario de la base de datos?')) return;
        if (!window.confirm('Esta acción también eliminará su acceso. ¿Estás completamente seguro?')) return;

        try {
            await apiDeleteUser(uid);
            fetchUsers();
            alert('Usuario eliminado correctamente.');
        } catch (error) {
            alert('Error al eliminar usuario.');
            console.error(error);
        }
    }

    function resetUserForm() {
        setNombre('');
        setEmail('');
        setPassword('');
        setMatricula('');
        setNomina('');
        setRole('user');
        setSelectedUser(null);
        setError(null);
    }

    function exportToExcel() {
        const aExportar = selectedIds.length > 0
            ? filteredInfracciones.filter(i => selectedIds.includes(i.id))
            : filteredInfracciones;

        if (aExportar.length === 0) {
            alert("No hay infracciones para exportar.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(aExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Infracciones');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const file = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(file, 'infracciones.xlsx');
    }

    const toggleSelected = (id) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const handleGenerarTicket = async (inf) => {
        let agenteData = null;
        try {
            agenteData = await findUserByName(inf.agente);
        } catch (error) {
            console.warn("No se pudo obtener datos del agente para ticket:", error);
        }

        const form = {
            nombre: inf.infractor_nombre,
            apellidoPaterno: inf.infractor_apellido_paterno,
            apellidoMaterno: inf.infractor_apellido_materno,
            marca: inf.vehiculo_marca,
            submarca: inf.vehiculo_submarca,
            modelo: inf.vehiculo_modelo,
            color: inf.vehiculo_color,
            serieAuto: inf.vehiculo_serie_auto,
            placas: inf.vehiculo_placas,
            motivo: inf.motivo,
            articulos: inf.articulos,
            cantidadUMAs: inf.cantidadUMAs,
            cantidadDias: inf.cantidadDias,
            seRetuvo: inf.se_retuvo,
            calle: inf.calle,
            entreCalle: inf.entre_calle,
            yCalle: inf.y_calle,
            municipio: inf.municipio,
            colonia: inf.colonia,
            descripcion: inf.descripcion,
            folioInventario: inf.vehiculo_folio_inventario,
            deposito: inf.vehiculo_deposito,
            nombreAgente: agenteData?.nombre || "",
            nominaAgente: agenteData?.nomina || "",
            fecha: inf.fecha,
            hora: inf.hora,
        };

        const ticketFolio = inf?.id || inf?.folio || inf?.infraccion?.id || inf?.infraccion_id;
        generarTicket(form, ticketFolio);
    };


    const handleLogout = async () => {
        clearSessionData();
        window.location.href = "/login";
    };

    return (
        <div className="ap_admin-container">
            <AdminNavbar
                nombreSesion={nombreSesion}
                handleLogout={handleLogout}
                rolSesion={userRole}
            />

            <div className="ap_section" style={{ paddingBottom: '0' }}>
                <Dashboard infracciones={infracciones} />
            </div>

            {userRole !== 'director' && (
                <Modal show={showUserModal} onHide={() => { setShowUserModal(false); resetUserForm(); }} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedUser ? 'Modificar Usuario' : 'Añadir Usuario'}</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={selectedUser ? handleEditUser : handleAddUser}>
                        <Modal.Body>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">Nombre</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingresa nombre completo"
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                </div>

                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">Correo Electrónico</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="correo@ejemplo.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            disabled={Boolean(selectedUser)}
                                        />
                                    </Form.Group>
                                </div>

                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">
                                            {selectedUser ? 'Nueva Contraseña (opcional)' : 'Contraseña'}
                                        </Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder={selectedUser ? 'Dejar en blanco para conservar la actual' : 'Mínimo 8 caracteres'}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required={!selectedUser}
                                        />
                                    </Form.Group>
                                </div>

                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">Matrícula / Placa</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingresa matrícula"
                                            value={matricula}
                                            onChange={(e) => setMatricula(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                </div>

                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">Rol en Sistema</Form.Label>
                                        <Form.Select
                                            value={rol}
                                            onChange={(e) => setRole(e.target.value)}
                                         >
                                             <option value="user">Usuario</option>
                                             <option value="director">Director</option>
                                             <option value="admin">Administrador</option>
                                         </Form.Select>
                                      </Form.Group>
                                </div>

                                <div className="col-md-6">
                                    <Form.Group>
                                        <Form.Label className="fw-bold">Número de Nómina</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Ingresa número de nómina"
                                            value={nomina}
                                            onChange={(e) => setNomina(e.target.value)}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            {error && <p className="ap_error-message mt-3" style={{ margin: 0 }}>{error}</p>}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => { setShowUserModal(false); resetUserForm(); }}>
                                Cancelar
                            </Button>
                            <Button type="submit" variant="success">
                                {selectedUser ? 'Guardar Cambios' : 'Agregar Usuario'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}


            {userRole !== 'director' && (
            <div className="ap_section">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="m-0">Lista de Usuarios</h3>
                    <Button variant="success" onClick={() => { resetUserForm(); setShowUserModal(true); }}>
                        <i className="bi bi-person-plus-fill"></i> Añadir Usuario
                    </Button>
                </div>
                <Card className="ap_card">
                    <table className="ap_table">
                        <thead>
                            <tr>
                                <th>UID</th>
                                <th>Nombre</th>
                                <th>Matrícula</th>
                                <th>Nómina</th>
                                <th>Rol</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(user => (
                                <tr key={user.uid}>
                                    <td>{user.uid}</td>
                                    <td>{user.nombre}</td>
                                    <td>{user.matricula}</td>
                                    <td>{user.nomina}</td>
                                    <td>{user.rol}</td>
                                    <td>
                                        <Button size="sm" variant="outline-primary" onClick={() => {
                                            setSelectedUser(user);
                                            setNombre(user.nombre);
                                            setEmail(user.email);
                                            setMatricula(user.matricula);
                                            setRole(user.rol);
                                            setNomina(user.nomina || '');
                                            setShowUserModal(true);
                                        }}>
                                            <Pencil />
                                        </Button>{' '}
                                        <Button size="sm" variant="outline-danger" onClick={() => handleDeleteUser(user.uid)}>
                                            <Trash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            </div>
            )}

            <div className="ap_section">
                <h3>Lista de Infracciones <span className="text-muted" style={{ fontSize: '1.1rem' }}>({totalItems} encontradas / {infracciones.length} totales)</span></h3>
                <Card className="ap_card">
                    <div className="row g-2 mb-3">
                        <div className="col-md-5">
                            <Form.Label className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Búsqueda General</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por ID, Agente, Conductor o Fecha..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <Form.Label className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Severidad</Form.Label>
                            <Form.Select
                                value={filterIncidencia}
                                onChange={(e) => setFilterIncidencia(e.target.value)}
                            >
                                <option value="Todas">Todas</option>
                                <option value="Alta">Alta</option>
                                <option value="Media">Media</option>
                                <option value="Baja">Baja</option>
                            </Form.Select>
                        </div>
                        <div className="col-md-2">
                            <Form.Label className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Fecha Inicio</Form.Label>
                            <Form.Control
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <Form.Label className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>Fecha Fin</Form.Label>
                            <Form.Control
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <table className="ap_table">

                        <thead>
                            <tr>
                                <th></th>
                                <th>ID</th>
                                <th>Conductor</th>
                                <th>Agente</th>
                                <th>Motivo</th>
                                <th>Estatus</th>
                                <th>Fecha</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentInfracciones.map(inf => (
                                    <React.Fragment key={inf.id}>

                                        <tr>
                                            <td><input type="checkbox" checked={selectedIds.includes(inf.id)} onChange={() => toggleSelected(inf.id)} /></td>
                                            <td>{inf.id}</td>
                                            <td>{`${inf.infractor_nombre ?? ''} ${inf.infractor_apellido_paterno ?? ''} ${inf.infractor_apellido_materno ?? ''}`}</td>
                                            <td>{inf.agente}</td>
                                            <td>{inf.motivo}</td>
                                            <td>
                                                {inf.editada ? (
                                                    <span className="badge bg-success">Editada</span>
                                                ) : (
                                                    ""
                                                )}
                                            </td>
                                            <td>{inf.fecha}</td>
                                            <td>
                                                <Button size="sm" variant="info" onClick={() => setExpanded(expanded === inf.id ? null : inf.id)}>
                                                    {expanded === inf.id ? 'Ocultar' : 'Ver Detalles'}
                                                </Button>
                                            </td>
                                        </tr>

                                        {expanded === inf.id && (
                                            <tr>
                                                <td colSpan="8">
                                                    <div className={`ap_detalle-infraccion ${editingInfraccionId === inf.id ? 'editando' : ''}`}>
                                                        <div className="ap_floating-buttons">
                                                            {editingInfraccionId === inf.id ? (
                                                                <>
                                                                    <Button size="sm" variant="success" onClick={handleSaveInfraccion}>
                                                                        <i className="bi bi-check-circle-fill"></i> Guardar
                                                                    </Button>
                                                                    <Button size="sm" variant="secondary" onClick={() => {
                                                                        setEditingInfraccionId(null);
                                                                        setEditedInfraccionData({});
                                                                    }}>
                                                                        <i className="bi bi-x-circle-fill"></i> Cancelar
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                     {userRole !== 'director' && (
                                                                         <Button size="sm" variant="primary" onClick={() => {
                                                                             setEditedInfraccionData({ ...inf });
                                                                             setEditingInfraccionId(inf.id);
                                                                         }}>
                                                                             <i className="bi bi-pencil-fill"></i> Modificar
                                                                         </Button>
                                                                     )}
                                                                     <Button size="sm" variant="dark" onClick={() => handleGenerarTicket(inf)}>
                                                                         <i className="bi bi-printer-fill"></i> Imprimir
                                                                     </Button>
                                                                     {userRole !== 'director' && (
                                                                         <Button size="sm" variant="danger" onClick={() => openDeleteModal(inf)}>
                                                                             <i className="bi bi-trash-fill"></i> Eliminar
                                                                         </Button>
                                                                     )}
                                                                 </>
                                                            )}
                                                        </div>
                                                        <div className="row">

                                                            <p className="ap_section-title">DATOS DEL AGENTE</p>
                                                            <div className="col-md-6">
                                                                <p><strong>Nombre del agente:</strong> {' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.agente || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, agente: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.agente
                                                                    )}
                                                                </p>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <p><strong>Serie del Equipo:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.serie_equipo || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, serie_equipo: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.serie_equipo
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <hr />


                                                        <p className="ap_section-title">DATOS DE LA INFRACCIÓN</p>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <p><strong>Conductor Ausente:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            label={editedInfraccionData.conductor_ausente ? 'Sí' : 'No'}
                                                                            checked={!!editedInfraccionData.conductor_ausente}
                                                                            onChange={(e) =>
                                                                                setEditedInfraccionData({
                                                                                    ...editedInfraccionData,
                                                                                    conductor_ausente: e.target.checked
                                                                                })
                                                                            }
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.conductor_ausente ? 'Sí' : 'No'
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <p><strong>Motivación:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.motivo || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, motivo: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.motivo
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <p><strong>Documentos Retenidos:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.se_retuvo || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, se_retuvo: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.se_retuvo
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>Fecha:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="date"
                                                                            value={editedInfraccionData.fecha ? editedInfraccionData.fecha.split("T")[0] : ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, fecha: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.fecha || "—"
                                                                    )}
                                                                </p>
                                                                <p><strong>Hora:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="time"
                                                                            value={editedInfraccionData.hora || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, hora: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.hora || "—"
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <p><strong>Cantidad de UMAs:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={editedInfraccionData.cantidadUMAs || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, cantidadUMAs: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.cantidadUMAs
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Artículos Relacionados:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Select
                                                                            options={articulosData.map((art) => ({
                                                                                value: `${art.clave} - ${art.descripcion}`,
                                                                                label: `[${art.relevancia || "Baja"}] ${art.clave} - ${art.descripcion}`,
                                                                            }))}
                                                                            isMulti
                                                                            closeMenuOnSelect={false}
                                                                            hideSelectedOptions={false}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            value={getArticulosArray(editedInfraccionData.articulos).map((item) => {
                                                                                const parts = item.split(" - ");
                                                                                const clave = parts[0];
                                                                                const descripcion = parts.slice(1).join(" - ");
                                                                                return {
                                                                                    value: item,
                                                                                    label: `${clave} - ${descripcion}`,
                                                                                };
                                                                            })}
                                                                            onChange={(selectedOptions) => {
                                                                                const valores = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                                                                                setEditedInfraccionData({ ...editedInfraccionData, articulos: valores });
                                                                            }}
                                                                            placeholder="Selecciona artículos"
                                                                            isSearchable
                                                                        />
                                                                    ) : (
                                                                        (() => {
                                                                            try {
                                                                                const parsed = JSON.parse(inf.articulos);
                                                                                if (Array.isArray(parsed)) {
                                                                                    return parsed.join(", ");
                                                                                }
                                                                            } catch (e) {}
                                                                            return inf.articulos || "—";
                                                                        })()
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <hr />

                                                        <p className="ap_section-title">LUGAR DE LA INFRACCIÓN</p>
                                                        <div className="row">
                                                            <div className="col-md-2">
                                                                <p><strong>Calle:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.calle || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, calle: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.calle
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <p><strong>Entre Calle:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.entre_calle || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, entre_calle: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.entre_calle
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <p><strong>Y Calle:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.y_calle || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, y_calle: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.y_calle
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <p><strong>Municipio:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            as="select"
                                                                            value={editedInfraccionData.municipio || ''}
                                                                            onChange={(e) => setEditedInfraccionData({
                                                                                ...editedInfraccionData,
                                                                                municipio: e.target.value,
                                                                                // limpiar colonia si cambian municipio
                                                                                colonia: ''
                                                                            })}
                                                                            size="sm"
                                                                        >
                                                                            <option value="">Seleccione un municipio</option>
                                                                            {Object.keys(municipiosYColonias).map((municipio, index) => (
                                                                                <option key={index} value={municipio}>{municipio}</option>
                                                                            ))}
                                                                        </Form.Control>
                                                                    ) : (
                                                                        inf.municipio
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Colonia:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            as="select"
                                                                            value={editedInfraccionData.colonia || ''}
                                                                            onChange={(e) => setEditedInfraccionData({
                                                                                ...editedInfraccionData,
                                                                                colonia: e.target.value
                                                                            })}
                                                                            size="sm"
                                                                            disabled={!editedInfraccionData.municipio} // deshabilitado si no hay municipio seleccionado
                                                                        >
                                                                            <option value="">Seleccione una colonia</option>
                                                                            {editedInfraccionData.municipio && municipiosYColonias[editedInfraccionData.municipio].map((colonia, index) => (
                                                                                <option key={index} value={colonia}>{colonia}</option>
                                                                            ))}
                                                                        </Form.Control>
                                                                    ) : (
                                                                        inf.colonia
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <hr />

                                                        <p className="ap_section-title">DATOS DEL CONDUCTOR</p>
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <p><strong>Conductor:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_nombre || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_nombre: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        `${inf.infractor_nombre ?? ''} ${inf.infractor_apellido_paterno ?? ''} ${inf.infractor_apellido_materno ?? ''}`
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>RFC:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_rfc || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_rfc: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_rfc
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Número de licencia:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_licencia || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_licencia: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_licencia
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-5">
                                                                <p><strong>Fecha de emisión:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="date"
                                                                            value={editedInfraccionData.infractor_emision ? editedInfraccionData.infractor_emision.split("T")[0] : ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_emision: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_emision
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Años de vigencia:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={editedInfraccionData.vigencia || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vigencia: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vigencia
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Tipo de Licencia:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_tipo_licencia || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_tipo_licencia: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_tipo_licencia
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <hr />

                                                        <p className="ap_section-title">DOMICILIO DEL CONDUCTOR</p>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>Calle:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_calle || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_calle: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_calle
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Número Exterior:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_num_exterior || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_num_exterior: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_num_exterior
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Número Interior:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_num_interior || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_num_interior: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_num_interior
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-2">
                                                                <p><strong>C.P.:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_codigo_postal || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_codigo_postal: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_codigo_postal
                                                                    )}
                                                                </p>
                                                            </div>

                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>Colonia:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            as="select"
                                                                            value={editedInfraccionData.infractor_colonia || ''}
                                                                            onChange={(e) =>
                                                                                setEditedInfraccionData({
                                                                                    ...editedInfraccionData,
                                                                                    infractor_colonia: e.target.value
                                                                                })
                                                                            }
                                                                            size="sm"
                                                                            disabled={!editedInfraccionData.infractor_municipio} // deshabilitado si no hay municipio
                                                                        >
                                                                            <option value="">Seleccione una colonia</option>
                                                                            {editedInfraccionData.infractor_municipio &&
                                                                                municipiosYColonias[editedInfraccionData.infractor_municipio].map((colonia, index) => (
                                                                                    <option key={index} value={colonia}>{colonia}</option>
                                                                                ))
                                                                            }
                                                                        </Form.Control>
                                                                    ) : (
                                                                        inf.infractor_colonia
                                                                    )}
                                                                </p>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <p><strong>Municipio:</strong>{' '}
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            as="select"
                                                                            value={editedInfraccionData.infractor_municipio || ''}
                                                                            onChange={(e) =>
                                                                                setEditedInfraccionData({
                                                                                    ...editedInfraccionData,
                                                                                    infractor_municipio: e.target.value,
                                                                                    infractor_colonia: '' // limpiar colonia al cambiar municipio
                                                                                })
                                                                            }
                                                                            size="sm"
                                                                        >
                                                                            <option value="">Seleccione un municipio</option>
                                                                            {Object.keys(municipiosYColonias).map((municipio, index) => (
                                                                                <option key={index} value={municipio}>{municipio}</option>
                                                                            ))}
                                                                        </Form.Control>
                                                                    ) : (
                                                                        inf.infractor_municipio
                                                                    )}
                                                                </p>
                                                            </div>

                                                            <div className="col-md-4">
                                                                <p><strong>Estado:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.infractor_estado || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, infractor_estado: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.infractor_estado
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>


                                                        <hr />

                                                        <p className="ap_section-title">DATOS DEL VEHÍCULO</p>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <p><strong>Placas:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_placas || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_placas: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_placas
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Número de Serie:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_serie_auto || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_serie_auto: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_serie_auto
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Expedido En:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_expedido_en || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_expedido_en: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_expedido_en
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Marca:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_marca || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_marca: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_marca
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <p><strong>Submarca:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_submarca || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_submarca: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_submarca
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Color:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_color || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_color: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_color
                                                                    )}
                                                                </p>
                                                            </div>

                                                            <div className="col-md-3">
                                                                <p><strong>Modelo:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_modelo || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_modelo: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_modelo
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Tarjeta de Circulación:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_tarjeta_circulacion || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_tarjeta_circulacion: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_tarjeta_circulacion
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <p><strong>Folio de Inventario:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_folio_inventario || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_folio_inventario: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_folio_inventario
                                                                    )}
                                                                </p>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <p><strong>Depósito:</strong>
                                                                    {editingInfraccionId === inf.id ? (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={editedInfraccionData.vehiculo_deposito || ''}
                                                                            onChange={(e) => setEditedInfraccionData({ ...editedInfraccionData, vehiculo_deposito: e.target.value })}
                                                                            size="sm"
                                                                        />
                                                                    ) : (
                                                                        inf.vehiculo_deposito
                                                                    )}
                                                                </p>

                                                            </div>
                                                        </div>



                                                        <hr />
                                                        <p className="ap_section-title">FOTOGRAFÍAS</p>
                                                        {editingInfraccionId === inf.id ? (
                                                            <div className="ap_foto-editando">
                                                                <div className="row">
                                                                    {["panoramica", "placa", "licencia", "tarjeta"].map((tipo, idx) => (
                                                                        <div className="col-md-3" key={idx}>
                                                                            <p className="fw-semibold">{`Foto ${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`}</p>
                                                                            {editedInfraccionData[`foto_${tipo}`] && (
                                                                                <a href={editedInfraccionData[`foto_${tipo}`]} target="_blank" rel="noopener noreferrer">
                                                                                    <img
                                                                                        src={editedInfraccionData[`foto_${tipo}`]}
                                                                                        alt={tipo}
                                                                                        className="img-thumbnail mb-2"
                                                                                        style={{ width: "100%", height: "auto", cursor: "pointer", border: "2px solid #dc3545" }}
                                                                                    />
                                                                                </a>
                                                                            )}
                                                                            <Form.Control
                                                                                type="file"
                                                                                accept="image/*"
                                                                                size="sm"
                                                                                className="mb-2"
                                                                                onChange={async (e) => {
                                                                                    const file = e.target.files[0];
                                                                                    if (file) {
                                                                                        try {
                                                                                            const publicUrl = await uploadInfraccionPhoto(file, tipo, "admin-update");
                                                                                            setEditedInfraccionData((prev) => ({
                                                                                                ...prev,
                                                                                                [`foto_${tipo}`]: publicUrl,
                                                                                            }));
                                                                                        } catch (error) {
                                                                                            alert("Error al subir imagen");
                                                                                            console.error(error);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="row">
                                                                {["panoramica", "placa", "licencia", "tarjeta"].map((tipo, idx) => (
                                                                    <div className="col-md-3" key={idx}>
                                                                        <p className="fw-semibold">{`Foto ${tipo.charAt(0).toUpperCase() + tipo.slice(1)}`}</p>
                                                                        {inf[`foto_${tipo}`] ? (
                                                                            <a href={inf[`foto_${tipo}`]} target="_blank" rel="noopener noreferrer">
                                                                                <img
                                                                                    src={inf[`foto_${tipo}`]}
                                                                                    alt={tipo}
                                                                                    className="img-thumbnail"
                                                                                    style={{ width: "100%", height: "auto", cursor: "pointer", border: "2px solid #dc3545" }}
                                                                                />
                                                                            </a>
                                                                        ) : (
                                                                            <span className="text-muted">No disponible</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                    </div>

                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                        </tbody>
                    </table>

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                            <span className="text-muted" style={{ fontSize: '0.9rem' }}>
                                Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, totalItems)} de {totalItems} infracciones (Página {currentPage} de {totalPages})
                            </span>
                            <div className="d-flex gap-1">
                                <Button 
                                    size="sm" 
                                    variant="outline-secondary" 
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    Anterior
                                </Button>
                                {Array.from({ length: totalPages }, (_, idx) => idx + 1).map(page => (
                                    <Button 
                                        key={page}
                                        size="sm" 
                                        variant={page === currentPage ? "primary" : "outline-secondary"}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                    </Button>
                                ))}
                                <Button 
                                    size="sm" 
                                    variant="outline-secondary" 
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                >
                                    Siguiente
                                </Button>
                            </div>
                        </div>
                    )}
                </Card >

                <div className="ap_export-buttons">
                    <Button onClick={exportToExcel} variant="success"><FileEarmarkExcel /> Exportar Excel</Button>
                    <Button onClick={() => exportToPDF(filteredInfracciones, selectedIds)} variant="danger">
                        <FileEarmarkPdf /> Exportar PDF
                    </Button>
                </div>
            </div >
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar infracción</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Escribe el motivo por el cual deseas eliminar esta infracción:</p>
                    <Form.Control
                        as="textarea"
                        value={deleteReason}
                        onChange={(e) => setDeleteReason(e.target.value)}
                        rows={3}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</Button>
                    <Button variant="danger" onClick={confirmDeleteInfraccion}>Eliminar</Button>
                </Modal.Footer>
            </Modal>

        </div >


    );
}
